import cx from 'classnames';
import React from 'react';
import { Controller } from 'react-hook-form';
import MaskedInput from 'react-text-mask';
import { FormGroup, Label } from 'reactstrap';
import type { InputType } from 'reactstrap/types/lib/Input';

import SingleErrorDisplay from '../../error-display/single-error-display';
import { useFormFieldContext } from '../../form-hook';

import styles from './phone-field.module.scss';

interface PhoneInputProps {
  label: string;
  id?: string;
  required?: boolean;
  name: string;
  type?: InputType;
  maxLength?: number;
}

export default function PhoneInput({
  label,
  name,
  id,
  required,
  ...rest
}: PhoneInputProps) {
  const {
    isNotValid,
    value,
    form: { control },
  } = useFormFieldContext(name);

  return (
    <FormGroup>
      {label ? (
        <Label
          className={cx(required && 'required', value && 'stay')}
          for={name}
        >
          {label}
        </Label>
      ) : null}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, onBlur } }: any) => (
          <MaskedInput
            required={required}
            id={id}
            {...rest}
            value={value}
            onBlur={onBlur}
            name={name}
            className={cx(
              {
                [styles.isInvalid]: isNotValid,
              },
              'form-control mb-2'
            )}
            type="tel"
            onChange={(e: any) => {
              const v = e?.target?.value;

              if (onChange) {
                onChange(v);
              }
            }}
            mask={() => {
              return [
                /[1-9]/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ];
            }}
            guide={false}
          />
        )}
      />
      <SingleErrorDisplay field={name} />
    </FormGroup>
  );
}
